// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5338) return "static/chunks/5338-e1074ffd29656919.js";
	if (chunkId === 8043) return "static/chunks/8043-676d360b866b308d.js";
	if (chunkId === 3811) return "static/chunks/3811-13ea844dd6541658.js";
	if (chunkId === 3109) return "static/chunks/3109-c979278f9dd3921b.js";
	if (chunkId === 8640) return "static/chunks/8640-a267909925e48fa7.js";
	if (chunkId === 1107) return "static/chunks/1107-b3f2e58e5ff899df.js";
	if (chunkId === 3106) return "static/chunks/3106-31f0de41661377d2.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"2084":"9b0008ae","4628":"b645e135"}[chunkId] || chunkId) + "." + {"1465":"160d601eecff9e10","2084":"8280082ed0947bdc","3160":"4806e0a413c64230","3602":"f4ac086d27f93d22","4628":"f0083acd9117533c","5446":"95f922a656a146df","5983":"d341cc4e40ccd7eb","7726":"7ef570c7c7da665f","7734":"77b5bcfbca3381be","8074":"ded1e74b653430cb","8364":"10a8c73e2a3158e1"}[chunkId] + ".js";
};